<template>
  <the-sidebar-layout>
    <div class="user-settings-sidebar" slot="sidebar">
      <router-link class="v-router-link" :to="{ name: 'change-password'}">{{loc('changePassword')}}</router-link><br>
      <router-link class="v-router-link" :to="{ name: 'edit-account'}">{{loc('editAccountInformation')}}</router-link>
    </div>
    <router-view></router-view>
  </the-sidebar-layout>
</template>

<script>

export default {
  name: 'ViewUserSettings',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  mounted: function () {
    this.$store.commit('setSubheader', {
      subtitle: '',
      title: '',
      description: '',
      searchEnabled: false
    });
  }
}
</script>

<style>
</style>
